import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { SET_LOADER } from '../redux/Loader';
import { FETCH_NEW_OFFERS_COUNT, FETCH_NEW_OFFERS_COUNT_FAIL, FETCH_NEW_OFFERS_COUNT_SUCCESS } from '../redux/VehicleTypeReducer';

function* FetchNewOffersCountFlow() {
  try {
    const endpoint = `${apiRoot}/offers/new_offers_count`;
    yield put(SET_LOADER({ value: true, }));
    const response = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_NEW_OFFERS_COUNT_SUCCESS(response));
  } catch (error) {
    yield put(FETCH_NEW_OFFERS_COUNT_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* FetchNewOffersCount() {
  yield takeLatest(FETCH_NEW_OFFERS_COUNT, FetchNewOffersCountFlow);
}
